"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.facebookMessenger = void 0;
var facebookMessenger = {
  commentBackground: '#f0f0f0',
  highlight: '#0084ff',
  disabledIcon: '#bcc0c4'
};
exports.facebookMessenger = facebookMessenger;
//# sourceMappingURL=facebookMessenger.js.map